import React from 'react';
import { Col, Divider, Input, Modal, Row, Select, Typography, Button } from 'antd';
import { FilterFilled } from '@ant-design/icons';
import PhoneInput from 'react-phone-input-2';
import { useAuthContext } from 'contexts/Auth';
import { useDataContext } from 'contexts/Data';

const { Text } = Typography;
const { Option } = Select;

export default function FilteredModal({ open, filtered, setFiltered, handleFilterStudents, handleClose }) {

    const { cnic, sortOrder, registrationNumber, fullName, email, phone } = filtered;
    const { isSuperAdminOrOwner } = useAuthContext();

    return (
        <Modal open={open} onCancel={handleClose} onClose={handleClose} centered footer={false} className='filter-modal' width={850}>
            <Text strong>Filter Students</Text>
            <Divider className='my-2' />

            <Row gutter={[12, 12]}>
                <Col xs={24} sm={isSuperAdminOrOwner ? 12 : 24}><Input placeholder="Full Name" value={fullName} onChange={(e) => setFiltered((s) => ({ ...s, fullName: e.target.value }))} /></Col>
                <Col xs={24} sm={12}><Input placeholder="CNIC" maxLength={13} value={cnic} onChange={(e) => setFiltered((s) => ({ ...s, cnic: e.target.value }))} /></Col>
                <Col xs={24} sm={12}><Input placeholder="Email" type="email" value={email} onChange={(e) => setFiltered((s) => ({ ...s, email: e.target.value }))} /></Col>
                <Col xs={24} sm={12}><Input placeholder="Register Number (000005)" value={registrationNumber} onChange={(e) => setFiltered((s) => ({ ...s, registrationNumber: e.target.value }))} /></Col>
                <Col xs={24} sm={12}><PhoneInput country={'pk'} value={phone} inputStyle={{ width: '100%' }} onChange={(value) => setFiltered((s) => ({ ...s, phone: value }))} /></Col>
                {/* <Col xs={12} sm={6}><Input placeholder="Per Page" onKeyPress={window.onlyNumber} value={perPage} onChange={(e) => setFiltered((s) => ({ ...s, perPage: e.target.value }))} /></Col>
                <Col xs={12} sm={6}><Input placeholder="Page No" onKeyPress={window.onlyNumber} value={pageNo} onChange={(e) => setFiltered((s) => ({ ...s, pageNo: e.target.value }))} /></Col> */}

                <Col xs={24} sm={24}><Select placeholder="Sort Order" className="w-100" value={sortOrder} defaultValue={sortOrder} onChange={(value) => setFiltered((s) => ({ ...s, sortOrder: value }))}
                    options={[{ label: "Latest", value: 'latest' }, { label: "Oldest", value: 'oldest' }, { label: "A - Z", value: 'a-z' }, { label: "Z - A", value: 'z-a' },]} />
                </Col>

                <Col xs={24} className="d-flex justify-content-end"><Button type="primary" className="w-25" icon={<FilterFilled />} onClick={handleFilterStudents}>Filter</Button></Col>
            </Row>
        </Modal>
    );
}
